import Game from 'Game';
import { getPlatformExtensionToResources } from 'Utility/Platform';
import { IAPReward } from 'Utility/RewardHelper';
import { ProductId } from 'Utility/Product';
import { report } from 'report';
import { GameActions } from 'State/Game/GameActions';

export async function handleIAP() {
    const supported: boolean = await Game.sdk.waitForPaymentsEnabled();

    if (!supported) return;

    const fetchCatalogSucceed = await Game.sdk.fetchCatalog();
    if (!fetchCatalogSucceed) return;

    const unconsumedPurchases = await Game.sdk.resolveUnconsumedPurchases();

    if (!Game.resource.existsAndLoaded('IAPRewards')) {
        if (!Game.resource.existsOrQueued('IAPRewards')) {
            Game.resource.add(
                'IAPRewards',
                `resource/data/rewards/IAPRewards.json`
            );
        }
        await Game.resource.load();
    }

    // TODO: what if `ProductId` doesn't match?
    const IAPRewardData: IAPReward[] = Game.resource.get('IAPRewards');
    const iapRewardById: { [key in ProductId]?: IAPReward } = Object.fromEntries(IAPRewardData.map(r => [r.id, r]));

    const filteredRewards: IAPReward[] = unconsumedPurchases.map((id: ProductId) => iapRewardById[id]).filter(Boolean);

    const failedIds = unconsumedPurchases.filter((id: ProductId) => !iapRewardById[id]);

    if (failedIds.length > 0) {
        report('Failed to find reward data for unconsumed purchases', {
            tags: {
                failedIds: `"${failedIds.join('","')}"`,
            },
            fingerprint: 'MissingRewardData4UnconsumedPurchase',
        });
    }

    GameActions.enableIAP(filteredRewards);
}
